import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import 'bootstrap/dist/css/bootstrap.css';
// import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js';
// import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';

createApp(App).use(store).use(router).mount('#app');
